<template>
    <v-dialog v-model="confirmDialog.show" scrollable max-width="540" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
        <v-card class="confirm-dialog">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon class="dialog-close" v-on="on" @click="confirmDialog.show = false" :disabled="confirmStatusLoading">close</v-icon>
                </template>
                <span>Close</span>
            </v-tooltip>
            <v-card-title class="dialog-title pb-2 font-weight-bold">
                {{ confirmDialog.data.modalTitle }}
            </v-card-title>
            <v-card-text class="pb-2">
                <p class="dialog-description font-size-21 ma-0">
                    {{ confirmDialog.data.modalDescription }}
                </p>
            </v-card-text>
            <v-card-actions>
                <v-container fluid>
                    <v-row align="center" justify="center">
                        <v-col cols="6" class="d-flex justify-center">
                            <v-btn
                                class="btn-modal-action-cancel btn-min-width no-text-transform"
                                text
                                :disabled="confirmStatusLoading"
                                @click="
                                    $emit('modalAction', {
                                        action: 'cancel',
                                        data: confirmDialog.data
                                    })
                                "
                                height="45"
                                block
                                outlined
                            >
                                No, cancel
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-center">
                            <v-btn
                                class="btn-modal-action-confirm confirm-btn btn-min-width no-text-transform"
                                depressed
                                :color="confirmDialog.action == 'delete' || !confirmDialog.data.is_active ? 'error' : 'success'"
                                :loading="confirmStatusLoading"
                                @click="
                                    $emit('modalAction', {
                                        action: confirmDialog.action,
                                        data: confirmDialog.data
                                    })
                                "
                                height="45"
                                block
                            >
                                Yes, {{ confirmation }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AppModal',
    props: {
        confirmStatusLoading: {
            type: Boolean,
            default: false
        },
        confirmDialog: Object
    },
    computed: {
        confirmation() {
            let confirmation = '';

            if (this.confirmDialog.proceed) {
                confirmation = this.confirmDialog.proceed;
            } else if (this.confirmDialog.action == 'delete') {
                confirmation = 'Delete';
            } else {
                if (this.confirmDialog.data.is_active) {
                    confirmation = 'Activate';
                } else {
                    confirmation = 'Deactivate';
                }
            }

            return confirmation;
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-modal-action-cancel {
    color: #16192c !important;
}

.btn-modal-action-confirm {
    color: #f5f5f5 !important;
}

.dialog-close {
    color: #5a6678;
}

.dialog-title {
    color: #16192c;
}

.dialog-description {
    color: #425466;
}
</style>
